import React from "react";
import { GiftIcon } from "lucide-react";
import { CtaButton } from "../CtaButton";
import { SectionHeading } from "../SectionHeading";
import { bonuses } from "../../data/landing";
export function Bonuses() {
  return <section className="bg-cream px-4 py-16 sm:py-24" data-id="element-115" data-mp="1clzc0idd4o2w">
      <div className="mx-auto max-w-5xl" data-id="element-116" data-mp="18jkr7sq4ve8z">
        <div className="mb-4 flex justify-center" data-id="element-117" data-mp="18kvw5vvbes1o">
          <span className="flex h-14 w-14 items-center justify-center rounded-2xl bg-gold text-navy" data-id="element-118" data-mp="259v4favwfttv">
            <GiftIcon className="h-7 w-7" aria-hidden="true" data-id="element-119" data-mp="20b0dtmrox0z7" />
          </span>
        </div>
        <SectionHeading title={<>
              5 exclusive bonuses — <span className="text-cta" data-id="element-121" data-mp="1wb9ozolq4uxb">included free today</span>
            </>} data-id="element-120" data-mp="1w95egntbkxo2" />

        <ol className="mt-12 space-y-10" data-id="element-122" data-mp="1rcez62pca63p">
          {bonuses.map((b, i) => <li key={b.number} className="-mx-4 overflow-hidden bg-white shadow-[0_8px_30px_-12px_rgba(11,27,58,0.2)] sm:mx-0 sm:rounded-3xl md:grid md:grid-cols-2 md:items-center" data-id="element-123" data-mp="kvbdle32pwsx" data-mpi={i}>
              <div className={`bg-white ${i % 2 === 1 ? "md:order-2" : ""}`} data-id="element-124" data-mp="1eru5qw6zcxgd">
                <img src={b.image} alt={`Bonus #${b.number}: ${b.title}`} className="block w-full" loading="lazy" data-id="element-125" data-mp="1jryjiegi7e2w" />
              </div>
              <div className="px-5 pb-8 pt-2 sm:px-8 md:py-10" data-id="element-126" data-mp="1artcw6j4wjps">
                <span className="inline-block rounded-md bg-gold px-3 py-1 text-sm font-extrabold uppercase tracking-wider text-navy" data-id="element-127" data-mp="1aq8luqw13iwo">
                  Bonus #{b.number}
                </span>
                <h3 className="mt-3 font-serif text-[1.7rem] font-bold leading-tight text-navy sm:text-3xl" data-id="element-128" data-mp="10v6tlm6gi0pv">{b.title}</h3>
                <p className="mt-2 text-lg" data-id="element-129" data-mp="n0nzdy0o23in">
                  <span className="text-navy/50 line-through" data-id="element-130" data-mp="r5443vyjn4wa">Value: ${b.value}</span>{" "}
                  <strong className="ml-1 text-cta" data-id="element-131" data-mp="d41g3dnznkiq">FREE</strong>
                </p>
                <p className="mt-4 text-[16px] leading-relaxed text-ink/80" data-id="element-132" data-mp="i3xjpbsrx9xr">{b.text}</p>
                <p className="mt-4 font-semibold text-navy" data-id="element-133" data-mp="2jsjywr541xmm">{b.kicker}</p>
              </div>
            </li>)}
        </ol>

        <div className="mt-12" data-id="element-134" data-mp="2f0se6x8mym4e">
          <CtaButton label="Yes! I want my 5 free bonuses" data-id="element-135" data-mp="2f0jyyyp1j4q1" />
        </div>
      </div>
    </section>;
}